





































































import { $eventsBus } from "@/main";
import { VPopover, VClosePopover } from "v-tooltip";

export default {
  name: "TopPanel",
  components: {
    VPopover,
  },
  directives: {
    "close-popover": VClosePopover,
  },
  data: function () {
    return {
      canUndo: false,
      canRedo: false,
    };
  },
  computed: {
    undoRedoHistory: function () {
      return this.$undoRedoHistory;
    },
    deletedObjects: function () {
      return this.$store.state.deletedObjects;
    },
    userInfo: function () {
      return this.$store.state.userInfo;
    },
    muted: {
      // getter
      get: function () {
        return this.$store.state.muted;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("muted", newValue);
      },
    },
    keymap: function () {
      return {
        "ctrl+z": this.undo,
      };
    },
  },
  watch: {
    "undoRedoHistory.currentIndex": {
      handler(val) {
        this.canUndo = this.undoRedoHistory.canUndo();
        this.canRedo = this.undoRedoHistory.canRedo();
        //this.$forceUpdate();
      },
    },
  },
  methods: {
    /*     undo() {
      this.$store.commit("undoDeleteObjects");
      $eventsBus.$emit("saveUserWorkspace");

	}, */
    undo() {
      if (
        !this.canUndo //||
        //if one of modal window is open
        /* Object.keys(this.$store.getters.modalWindows).some(
          (k) => this.$store.getters.modalWindows[k]
        ) */
      ) {
        return;
      }
      this.$store.commit("undo");
      $eventsBus.$emit("saveUserWorkspace", true);
    },
    redo() {
      if (
        !this.canRedo //||
        //if one of modal window is open
        /* Object.keys(this.$store.getters.modalWindows).some(
          (k) => this.$store.getters.modalWindows[k]
        ) */
      ) {
        return;
      }
      this.$store.commit("redo");
      $eventsBus.$emit("saveUserWorkspace", true);
    },
    muteClick() {
      this.muted = !this.muted;
    },
    openMenu() {
      this.$refs.arrow.click();
    },
    logout() {
      this.$store.state.userInfo.sessionId = null;
      this.$cookies.remove("sessionId");
      this.$router.push("/login");
      this.$store.state.userInfo.id = -1;
      this.$store.state.userInfo.firstName = "";
      this.$store.state.userInfo.lastName = "";

    },
    getUserNameInitials() {
      return this.userInfo.avatar
        ? ""
        : this.userInfo.firstName !== "" && this.userInfo.lastName !== ""
        ? this.userInfo.firstName[0].toUpperCase() +
          this.userInfo.lastName[0].toUpperCase()
        : "R";
    },
  },
};
